import { render, staticRenderFns } from "./DailyAlertsChart.vue?vue&type=template&id=899131ee&scoped=true"
import script from "./DailyAlertsChart.vue?vue&type=script&lang=js"
export * from "./DailyAlertsChart.vue?vue&type=script&lang=js"
import style0 from "./DailyAlertsChart.vue?vue&type=style&index=0&id=899131ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899131ee",
  null
  
)

export default component.exports